import { transform } from './mapper.js'

const recipientReference = {
  name: 'Recipient Reference'
}

const mapping = [
  {
    fhir: [ 'agent', 0, 'reference', 'display' ],
    form: [ 'user' ]
  },
  {
    fhir: [ 'outcome' ],
    form: [ 'outcome' ]
  },
  {
    fhir: [ 'type', 'code' ],
    form: [ 'type' ]
  },
  {
    fhir: [ 'recorded' ],
    form: [ 'recorded' ]
  },
  {
    fhir: [ 'entity', recipientReference, 'reference', 'display' ],
    form: [ 'recipient' ]
  },
  {
    fhir: [ 'entity', recipientReference, 'identifier', 'value' ],
    form: [ 'address' ]
  }
]

export function fromFHIR (data) {
  return transform(data, mapping, [ 'fhir', 'form' ])
}
